import React from 'react'
import {connect} from 'react-redux'
import {CompanySelector} from '/app/src/model'

import DeleteCompany from './DeleteCompany'
import CancelSubscription from './CancelSubscription'


class EndJibberContainer extends React.Component {
    render() {
        const {hasCanceled} = this.props
        const page = hasCanceled ? <DeleteCompany />  : <CancelSubscription />
        return page
    }
}

function mapStateToProps(state, props) {
    const hasCanceled = CompanySelector.getWillCancelSub(state)
    return { hasCanceled }
}

export default connect(mapStateToProps)(EndJibberContainer)



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/CompanySettings/EndSubscription/index.js